import React from 'react';


const SecuredPage = () => {

 return (
   <div>
     <h1 className="text-black text-4xl">Please wait...</h1>
   </div>
 );
};

export default SecuredPage;